import { render, staticRenderFns } from "./ClipItem.vue?vue&type=template&id=078c2943&scoped=true&"
import script from "./ClipItem.vue?vue&type=script&lang=js&"
export * from "./ClipItem.vue?vue&type=script&lang=js&"
import style0 from "./ClipItem.vue?vue&type=style&index=0&id=078c2943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078c2943",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSpacer,VTextarea,VTooltip})
